import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";

import { getClubInfo } from "../../api/clubs.api";
import leftArrow from "../../assets/backIcon.svg";
import {
  AMOUNT_SKELETON_NFTS,
  MESSAGE_TYPE,
} from "../../common/constants/common.constants";
import { CLUB_DETAILS } from "../../common/constants/routes.constants";
import VaultSection from "../../components/ClubDetails/OverviewClub/TreasuryVault/Vault";
import {
  IClubBasicInfo,
  IClubTreasury,
  IVault,
} from "../../common/interfaces/clubs.interface";
import {
  fetchBasicClubInfoFromSolana,
  getClubVault,
  getTreasuryForClub,
} from "../../solana/methods/clubs";

import "./Vault.scss";
import SkeletonItem from "../../components/SkeletonItem/SkeletonItem";

import { generateSkeletonArrays } from "../../utilities/helpers";
import { createNotification } from "../../utilities/notification";
import { PublicKey } from "@solana/web3.js";

const VaultPage = () => {
  const [vault, setVault] = useState<IVault>();
  const [club, setClub] = useState<IClubBasicInfo>();
  const [treasury, setTreasury] = useState<IClubTreasury>();
  const navigate = useNavigate();
  const [isLoading, toggleIsLoading] = useState(true);

  const { clubAddress } = useParams();

  const getClubData = async (clubAddress: string) => {
    try {
      toggleIsLoading(true);
      const club = await getClubInfo(clubAddress);
      const clubInfoFromSolana = await fetchBasicClubInfoFromSolana(
        club.address
      );
      if (!club || !clubInfoFromSolana) throw new Error("Club not found");
      setClub({
        ...club,
        roleConfig: clubInfoFromSolana?.roleConfig!,
        governances: clubInfoFromSolana?.governanceAccounts!,
        type: clubInfoFromSolana?.clubType!,
        numberOfMembers: clubInfoFromSolana?.numberOfMembers!,
        communityMint: new PublicKey(club.communityMintAddress),
      });
      const vault = await getClubVault(club.name);
      setVault(vault);
      const clubTreasury = await getTreasuryForClub(club.name);
      setTreasury(clubTreasury);
      toggleIsLoading(false);
    } catch (error) {
      createNotification(MESSAGE_TYPE.ERROR, "Failed to load club data");
    }
  };

  useEffect(() => {
    void getClubData(clubAddress!);
  }, []);

  const goToClubDetails = (): void => {
    navigate(`${CLUB_DETAILS}/${club!.address}`);
  };

  return (
    <div className="vault">
      <div className="vault__buttons">
        <button className="vault__button back" onClick={goToClubDetails}>
          <img src={leftArrow} alt="arrowBack" />
          Back to club
        </button>
      </div>
      {!isLoading ? (
        <div className="vault__nfts">
          <VaultSection
            treasuryData={treasury!}
            clubBasicInfoData={club!}
            nfts={vault?.nfts}
          />
        </div>
      ) : (
        <div className="skeleton">
          {generateSkeletonArrays(AMOUNT_SKELETON_NFTS).map((item) => {
            return (
              <div className="skeleton__nft" key={item}>
                <SkeletonItem width={240} height={240} borderRadius={20} />
                <SkeletonItem width={180} height={20} borderRadius={50} />
                <SkeletonItem width={150} height={15} borderRadius={50} />
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default VaultPage;
